export default __webpack_public_path__ + "static/ramanSharma5-6beb14eb0f5e3cc51d714ef1b80937ff.jpg";